import mixins from 'vue-typed-mixins';

import { E千円表示フラグ } from '@/openapi/enum';

import 計画書Mixin from '@/entries/user/mixins/計画書Mixin';
import 計画書データ表示設定Mixin from '@/entries/user/mixins/計画書データ表示設定Mixin';

import AbstractデータService from '@/classes/service/AbstractデータService';

export default mixins(計画書Mixin, 計画書データ表示設定Mixin).extend({
  name: 'MoneyUnitSelect',

  data(): {
    e千円表示フラグ: typeof E千円表示フラグ;
    c千円表示フラグ: E千円表示フラグ | null;
    経理方式Label: string;
  } {
    return {
      e千円表示フラグ: E千円表示フラグ,
      c千円表示フラグ: null,
      経理方式Label: AbstractデータService.get経理方式Label(),
    };
  },

  watch: {
    c千円表示フラグ: {
      handler(newVal: E千円表示フラグ, oldVal: E千円表示フラグ): void {
        if (oldVal === null) return;
        this.save計画書データ表示設定({ c千円表示フラグ: newVal });
      },
    },
  },

  created(): void {
    this.c千円表示フラグ = this.計画書.c千円表示フラグ;
  },
});
